export default {
    items: [
      {
        name: 'Dashboard',
        url: '/dashboard',
        icon: 'icon-screen-desktop',
      },
      {
        name: 'Training',
        url: '#',
        icon: 'graduation cap icon',
        children: [
          {
            name: 'Introduction',
            url: '/HHintrodction',
          },
          {
            name: 'Hand Hygiene',
            url: '/HhyVdo',
          },
          {
            name: '5 Moments',
            url: '/5Moments',
          },
          {
            name: 'Hand Hygiene Audit',
            url: '/HhAudit',
          },
          {
            name: '7 Steps',
            url: '/7Steps',
          },
          {
            name: 'Hand in Surgery',
            url: '/HandSurgery',
          },
        ]
      },
      {
        name: 'Assessment',
        url: '/assessment',
        icon: 'fa fa-check-square-o',
      },
      {
        name: 'Chart',
        url: '#',
        icon: 'icon-chart',
        children: [
          {
            name: 'Country',
            url: '/country',
          },
          {
            name: 'Region',
            url: '/region',
          },
          {
            name: 'Hospital',
            url: '/hospital',
          },
          {
            name: 'Department',
            url: '/department',
          },
          {
            name: 'Ward',
            url: '/ward',
          },
        ]
      },
      {
        name: 'User Profile',
        url: '/userpro',
        icon: 'icon-user',
      },
      {
        name: 'Manual',
        url: '/manual',
        icon: 'icon-book-open',
      },
      {
        name: 'Sign Out',
        url: '/logout',
        icon: 'icon-logout',
      },
  
    ],
  };
  
  


// WEBPACK FOOTER //
// ./src/_navGuest.js